import { render, staticRenderFns } from "./CustomTableTree.vue?vue&type=template&id=4c527617&scoped=true"
import script from "./CustomTableTree.vue?vue&type=script&lang=js"
export * from "./CustomTableTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c527617",
  null
  
)

export default component.exports